import React from 'react'
import { Table, Col, Row, Form } from "react-bootstrap"
import { useTranslation } from 'react-i18next';
import useIsMobile from '../hooks/mobile';
import Footer from './Footer';
import { Invoice } from '../types/invoiceForm';
import Hub3QrCode from './BankPaymentBarcodeQrcode';

export interface ShowInvoiceDetailsProps {
  invoice: Invoice;
}

const ShowInvoiceDetails: React.FC<ShowInvoiceDetailsProps> = ({ invoice }) => {
  const isMobile = useIsMobile();
  const { t } = useTranslation();  
 
  
  return (
    <div id="invoiceCapture" >
      <div className="d-flex flex-row justify-content-between align-items-start bg-light w-100 p-4">
        <div className="w-100">
          <h4 className="fw-bold my-2">{invoice?.from || 'Senad Mandžić'}</h4>
          <h6 className="fw-bold text-secondary mb-1">
            {t('invoice')}: {invoice?.invoiceNumber || ''}
          </h6>
        </div>         
        <div className="text-end ms-4">
          <h6 className="fw-bold mt-1 mb-2">{t('due')}&nbsp;{t('amount')}:</h6>
          <h5 className="fw-bold text-secondary"> {invoice?.currency} {invoice?.total}</h5>
        </div>
      </div>            

      <div className="p-4 bg-white">
        <Row className="mb-4">
          <Col className={isMobile? 'col-md-6' : 'col-12 col-md-6'}>
            <div className="fw-bold">{t('to')}:</div>
            <div>{invoice?.to || ''}</div>
            <div>{invoice?.toAddress || ''}</div>
            <div>{invoice?.toEmail || ''}</div>
            <div>{invoice?.toOib || ''}</div>
          </Col>
          <Col className={isMobile? 'col-md-6' : 'col-12 col-md-6'}>
            <div className="fw-bold">{t('from')}:</div>
            <div>{invoice?.from || ''}</div>
            <div>{invoice?.fromAddress || ''}</div>
            <div>{invoice?.fromEmail || ''}</div>
            <div>{invoice?.fromOib || ''}</div>
          </Col> 
        </Row>
        <Row className="mb-1">
          <Col className={isMobile? 'col-md-8' : 'col-12 col-md-8'}>
          { invoice?.paymentMethod  != 'bank' &&
                  <div className="bg-white shadow-sm rounded p-4 h-100 d-flex justify-content-center align-items-center" >
                   
                    <Hub3QrCode
                        payerName={invoice?.to}
                        payerAddress={invoice?.toAddress}
                        payerCity=""              
                        recipientName={invoice?.from} 
                        recipientAddress={invoice?.fromAddress || ''} 
                        recipientCity=""
                        recipientIBAN={invoice?.iban}
                        model="HR00"
                        reference={`${invoice?.invoiceNumber.split('/')[0]}-${invoice?.toOib}`}
                        amount={invoice?.total}
                        currency="EUR"
                        purpose={`${t('invoiceNumber')} ${invoice?.invoiceNumber}`}
                      />
                  </div>
          }
            
            </Col>
            <Col className={isMobile? 'col-md-6' : 'col-12 col-md-4'}>
                { invoice?.paymentMethod  != 'bank' && (
                  <>
                    <div className="fw-bold mt-2">{t('dueDate')}:</div>
                    <div>{invoice?.dueDate || ''}</div>
                  </>
                )}
                <div className="fw-bold mt-2">{t('issueDate')}:</div>
                <div>{invoice?.issueDate || ''}</div>

                {invoice?.paymentMethod  != 'bank' && (
                  <>
                    <div className="fw-bold mt-2">{t('iban')}:</div>
                    <div>{invoice?.iban || ''}</div>
                  </>
                )}

                {
                  invoice?.paymentMethod  != 'bank' && (
                    <>
                      <div className="fw-bold mt-2">{t('referenceNumber')}:</div>
                      <div>{`${invoice?.invoiceNumber.split('/')[0]}-${invoice?.toOib}`}</div>
                    </>
                )}
                
                {invoice?.madeBy && (
                  <>
                    <div className="fw-bold mt-2">{t('madeBy')}:</div>
                    <div>{invoice?.madeBy}</div>
                  </>
                )}        
              </Col>
        </Row>
        <Table className="mb-0">
          <thead>
            <tr>
              <th>{t('item.quantity')}</th>
              <th>{t('item.description')}</th>
              <th className="text-end">{t('item.price')}</th>
              <th className="text-end">{t('item.amount')}</th>
            </tr>
          </thead>
          <tbody>
            {invoice?.items.map((item, i) => {
              return (
                <tr id={i.toString()} key={i}>
                  <td style={{ width: '70px' }}>
                    {item?.quantity}
                  </td>
                  <td>
                    {item?.name} - {item?.description}
                  </td>
                  <td className="text-end" style={{ width: '100px' }}>{invoice?.currency} {item?.price}</td>
                  <td className="text-end" style={{ width: '100px' }}>{invoice?.currency} {(parseFloat(item?.price) * item?.quantity).toFixed(2)}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
        <Table>
          <tbody>
            <tr>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
            </tr>
            <tr className="text-end">
              <td></td>
              <td className="fw-bold" style={{ width: '100px' }}>{t('item.subtotal')}</td>
              <td className="text-end" style={{ width: '100px' }}>{invoice?.currency} {invoice?.subTotal}</td>
            </tr>
            {invoice?.taxAmmount !== '0.00' &&
              <tr className="text-end">
                <td></td>
                <td className="fw-bold" style={{ width: '100px' }}>{t('item.tax')}</td>
                <td className="text-end" style={{ width: '100px' }}>{invoice?.currency} {invoice?.taxAmmount}</td>
              </tr>
            }
            {invoice?.discountAmmount !== '0.00' &&
              <tr className="text-end">
                <td></td>
                <td className="fw-bold" style={{ width: '100px' }}>{t('item.discount')}</td>
                <td className="text-end" style={{ width: '100px' }}>{invoice?.currency} {invoice?.discountAmmount}</td>
              </tr>
            }
            <tr className="text-end">
              <td></td>
              <td className="fw-bold" style={{ width: '100px' }}>{t('item.total')}</td>
              <td className="text-end" style={{ width: '100px' }}>{invoice?.currency} {invoice?.total}</td>
            </tr>
          </tbody>
        </Table>       
        
        <Row className='p-0' style={{ minHeight: '100px' }}>
                         
          <div className="bg-white shadow-sm rounded p-4 d-flex flex-column">
            {invoice?.remark && (<Form.Label className="fw-bold d-block mb-2">{t('remark')}</Form.Label>)}
            <div className="d-flex flex-column">
              <div>{invoice?.taxRate  === '0.00' || invoice?.taxRate === '0' ? t('statement.tax') : ''}</div>
              <div className="text-muted mt-50 mt-3" style={{ whiteSpace: 'pre-wrap', marginTop: 'auto' }}>
                {invoice?.remark}
              </div>
            </div>            
          </div>              
           
           
        </Row> 
      </div>
        <Footer text={'statement.footer.invoice'}></Footer>
    </div>
  )
}

export default ShowInvoiceDetails
